import {
    CategorySuggestion,
    METADATA_FIELD_TYPE,
    NodeSuggestion,
    SearchSuggestion,
    DocNameSuggestion,
    PrefixSuggestion,
    HistoryRecordSuggestion,
    SearchData,
    DocNameSearchData,
    MetadataSuggestion,
    MetadataField
} from './interface';
import {DOC_NAME_SEARCH_PREFIX} from './hooks/use-suggestions-props';

export function isSearchCategory(
    suggestion: SearchSuggestion | SearchData
): suggestion is CategorySuggestion {
    return suggestion.type === 'category';
}

export function isSearchNode(
    suggestion: SearchSuggestion | SearchData
): suggestion is NodeSuggestion {
    return suggestion.type === 'node';
}

export function isNodeOrCategorySearchPrefix(prefix: string) {
    return prefix != DOC_NAME_SEARCH_PREFIX && !isMetadataPrefix(prefix);
}

export function isSearchByDocNameSuggestion(
    suggestion: SearchSuggestion
): suggestion is DocNameSuggestion {
    return suggestion.type === 'document';
}

export function isSearchByMetadata(suggestion: SearchSuggestion): suggestion is MetadataSuggestion {
    return suggestion.type === 'metadata';
}

export function isMetadataPrefix(prefix: string) {
    return Object.values(metadataFieldLabelsMap).includes(prefix);
}

export const metadataFieldLabelsMap: Record<MetadataField, string> = {
    [METADATA_FIELD_TYPE.PUBLISHED_BY]: 'published by',
    [METADATA_FIELD_TYPE.CREATED_BY]: 'created by',
    [METADATA_FIELD_TYPE.EDITED_BY]: 'edited by',
    [METADATA_FIELD_TYPE.TAG_PUBLIC]: 'tag',
    [METADATA_FIELD_TYPE.TAG_PRIVATE]: 'tag'
};

export const getUniqueMetadataLabels = (): string[] => {
    return [...new Set(Object.values(metadataFieldLabelsMap))];
};
export function getMetadataFieldLabel(field: MetadataField) {
    return metadataFieldLabelsMap[field];
}

export function isTagMetadataField(field: MetadataField) {
    return field === METADATA_FIELD_TYPE.TAG_PUBLIC || field === METADATA_FIELD_TYPE.TAG_PRIVATE;
}

export function getTagVisibilityLabel(field: MetadataField) {
    return field === METADATA_FIELD_TYPE.TAG_PRIVATE ? '(private)' : '(public)';
}

export function getMetadataFieldNameByLabel(label: string) {
    return Object.keys(metadataFieldLabelsMap).find(
        (key) => metadataFieldLabelsMap[key as MetadataField] === label
    );
}

export function isSearchByDocName(searchData: SearchData): searchData is DocNameSearchData {
    return searchData.type === 'document';
}

export function isPrefixSuggestion(suggestion: SearchSuggestion): suggestion is PrefixSuggestion {
    return suggestion.type === 'prefix';
}

export function isHistoryRecordSuggestion(
    suggestion: SearchSuggestion
): suggestion is HistoryRecordSuggestion {
    return suggestion.type === 'historyRecord';
}

export function getMatchedSynonym(suggestion: SearchSuggestion) {
    return (suggestion as CategorySuggestion | NodeSuggestion).matchedSynonym;
}

export function isInputValueNotEmpty(inputValue: string) {
    return /[^ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(inputValue);
}
